import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/rootReducer';
import { setAuthState } from '../Utils/auth';
import { authenticationSliceName, sharedSliceName } from './constants';

export const store = configureStore({
  reducer: rootReducer,
});

// Subscribe to store updates
store.subscribe(() => {
  const state = store.getState();
  const token = state[authenticationSliceName]?.auth0IdToken;
  const isRanByCypress = state[sharedSliceName]?.isRanByCypress;

  setAuthState({ token, isRanByCypress });
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
